import type { KadasterWozValue, WozCaseKadasterValue, WozCategoryCode, WozMainCategoryCode } from '@footsteps/types';
import { WozCategoriesMap, WozMainCategoriesMap } from '@footsteps/types';
import { formatDate, formatCurrency } from '@footsteps/shared';

export type WozLatestValue = {
  /** Dutch formatted date, e.g. "1 januari 2024" */
  referenceDate: string;
  /** Formatted euro amount without decimals, e.g. "€ 963.000" */
  assessedValue: string;
};

/** Get the latest WOZ value from a WozCaseKadasterValue list. */
export const getWozLatestValue = (values: WozCaseKadasterValue[] | KadasterWozValue[]): WozLatestValue | null => {
  if (values.length === 0) return null;

  const sorted = [...values].sort((a, b) => b.referenceDate.localeCompare(a.referenceDate));
  const latest = sorted[0];

  return {
    referenceDate: formatDate(latest.referenceDate, 'd MMMM yyyy'),
    assessedValue: formatCurrency(latest.assessedValue),
  };
};

export function getWozCategoryTitle(code: WozCategoryCode): string {
  return WozCategoriesMap[code].title;
}

export function getWozCategoryCodes(): WozCategoryCode[] {
  return Object.keys(WozCategoriesMap) as WozCategoryCode[];
}

export function getWozMainCategoryTitle(code: WozMainCategoryCode): string {
  return WozMainCategoriesMap[code].title;
}
